import type {ReactElement} from 'react';
import React from 'react';
import {Button, Size, Type} from '@Components/button';
import {Text, TextSize} from '@Components/text';
import styles from './button-item-secondary.module.scss';

interface ButtonItemSecondaryProps {
  id: string;
  className?: string;
  buttonText: string;
  buttonIcon?: string;
  text?: string;
  isDisabled?: boolean;

  onClick(id: string): void;
}

export function ButtonItemSecondary({className = '', text = '', isDisabled = false, buttonIcon = '', ...props}: ButtonItemSecondaryProps): ReactElement<any> | null {
  return (
    <div id={props.id} className={`${className} ${styles.buttonContainer} flex-column-align-center`}>
      <Button
        customClasses="-fullwidth"
        size={Size.SMALL}
        type={Type.SECONDARY}
        text={props.buttonText}
        icon={buttonIcon}
        onClick={(): void => {
          props.onClick(props.id);
        }}
        disabled={isDisabled}
      />
      {text ? <Text val={text} size={TextSize.XSMALL} className={`${isDisabled ? 'color-extra-light' : 'content-sub-text'}  spacing-m-t-1`} /> : null}
    </div>
  );
}
